import { IoCloseOutline } from 'react-icons/io5';
import SidebarTabs from './SidebarTabs';
import { useState } from 'react';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

type Project = {
  name: string;
  year?: string | number;
  location?: string;
  interiors?: string;
  awards?: string;
  about_project?: any;
  label: string;
  value: string;
  description?: { children?: { text?: string }[] }[];
  media: {
    desktop_media?: { url?: string }[];
  };
  video: any;
};

type DetailViewProps = {
  setActiveTab: React.Dispatch<React.SetStateAction<'grid' | 'list' | 'detail' | 'video'>>;
  project: Project;
};
type BlocksRendererProps = React.ComponentProps<typeof BlocksRenderer>;

export default function DetailView({ setActiveTab, project }: DetailViewProps) {
  const [mousePos, setMousePos] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };
  const videoEnable = project?.video?.enable_video_controls === true;

  return (
    <section className="relative min-h-screen">
      <div className="relative z-10 grid grid-cols-12 gap-4 lg:gap-5 py-5 left-mobile">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2 px-4 relative gap-2 lg:gap-5 ">
          <SidebarTabs
            setActiveTab={setActiveTab}
            activeTab="detail"
            position=""
            videoControlsEnabled={!!videoEnable}
          />
        </div>
      </div>

      <div
        className="col-span-12 text-[#2B332A] px-4 pt-[4rem] lg:pt-[10.7%] xl:pt-[14.9%] relative md:h-[calc(100dvh-21dvh)] flex flex-col justify-start"
        style={{ width: '100%', maxWidth: '100%' }}
        onMouseMove={handleMouseMove}
      >
        <div className="grid grid-cols-12 gap-6 text-[#2B332A] text-[12px] pb-8 lg:pb-0 middle-content">
          {/* Left Section */}
          <div className="col-span-12 lg:col-span-3">
            <h1 className="text-[18px] lg:text-[22px] font-light hidden sm:block leading-none">
              {project.name}
            </h1>
          </div>

          {/* Middle Section */}
          {/* {project.description?.[0]?.children?.[0]?.text && (
            <div className="col-span-12 lg:col-span-5 md:max-w-[640px] blocksRenderer">
              <p className="text-base mb-3 lg:mb-0 font-light leading-[23px] lg:leading-[23px] indent-10">
                {project?.description[0]?.children[0]?.text}
              </p>
            </div>
          )} */}

          <div className="col-span-12 lg:col-span-5 md:max-w-[640px] blocksRenderer">
            <div className="text-base mb-3 lg:mb-0 font-light leading-[23px] lg:leading-[23px] indent-10">
              <BlocksRenderer content={project.description as BlocksRendererProps['content']} />
            </div>
          </div>

          {/* Right Section */}
          <div className="col-span-12 lg:col-span-4 flex flex-col gap-5 lg:items-end justify-start">
            <div className="w-100 xl:w-[50%]">
              {project?.about_project.map((item: Project, index: number) => (
                <p
                  className="text-[13px] font-dm-mono leading-[17px] tracking-wide text-left pb-[28px]"
                  key={index}
                >
                  {item?.label.toUpperCase()}
                  <br />
                  {item?.value}
                </p>
              ))}
            </div>
          </div>
        </div>

        <button
          onClick={() => setActiveTab('list')}
          className="text-[#2B332A]  text-nowrap text-[12px] uppercase font-dm-mono absolute tracking-widest transition-opacity duration-300  items-center pointer-events-auto z-10 hidden md:flex"
          style={{
            left: `${mousePos.x}px`,
            top: `${mousePos.y}px`,
            transform: 'translate(-50%, -50%)',
            transition: 'left 0.03s, top 0.03s',
          }}
        >
          Close [ <IoCloseOutline /> ]
        </button>
      </div>
      <button
        onClick={() => setActiveTab('list')}
        className="flex items-center leading-none text-[16px] font-light top-5 md:top-auto md:bottom-5 transition-all left-5 md:left-0 cursor-pointer hover:text-[#9E703E] font-dm-mono z-[99] absolute flex md:hidden"
      >
        Close [ <IoCloseOutline /> ]
      </button>
    </section>
  );
}
